import { render, staticRenderFns } from "./ocr-padron.vue?vue&type=template&id=05f79bde&scoped=true&"
import script from "./ocr-padron.vue?vue&type=script&lang=js&"
export * from "./ocr-padron.vue?vue&type=script&lang=js&"
import style0 from "./ocr-padron.vue?vue&type=style&index=0&id=05f79bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f79bde",
  null
  
)

export default component.exports